import React, {useState} from 'react'
import { FaEdit } from "react-icons/fa";
import { AiFillDelete } from "react-icons/ai";
import Swal from 'sweetalert2';
import { useSelector, shallowEqual } from 'react-redux'
import { DeletePost } from '../api'
import CoachFeedEditModal from './CoachFeedEditModal';

const CoachFeedCard = ({post, handleGetPost, setSnackbar}) => {
  const { user } = useSelector(({ auth }) => auth, shallowEqual);
  const [show, setShow] = useState(false);
  const handleClose = () => setShow(false);
  const handleShow = () => {
    setShow(true)
  };

    const handleDelete = () => {
          Swal.fire({
            title: 'Are you sure?',
            text: "You won't be able to revert this!",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#3085d6',
            cancelButtonColor: '#d33',
            confirmButtonText: 'Yes, delete it!',
            showLoaderOnConfirm: true,
            preConfirm: (login) => {
              return DeletePost(post._id)
            },
            allowOutsideClick: () => !Swal.isLoading()
          }).then((result) => {
            if (result.isConfirmed) {
                console.log(result);
                Swal.fire(
                'Deleted!',
                result.value.data.message,
                'success'
                )
                handleGetPost()
            }
          })
    }
    return (
      <>
        <CoachFeedEditModal handleGetPost={handleGetPost} setSnackbar={setSnackbar} show={show} handleClose={handleClose} post={post}  />
        <div className='col-xl-3 col-lg-4 col-md-6 col-12 '>
            <div className=' px-4 py-4 shadow rounded-lg'>
                <div className='d-flex justify-content-end'>
                    <FaEdit onClick={handleShow} className='font2  mr-2' />
                    <AiFillDelete onClick={handleDelete} className='font2 ' />
                </div>
                <div className='pt-2'>
                    <h1>{post.title}</h1>
                    <img src={post.image} className='rounded-lg w-100' height={200} width={270} />
                    <p className='pt-3 font1'>{post.description}</p>
                </div>
            </div>
        </div>
      </>
    )
}

export default CoachFeedCard